import { RemoteConfigUtils } from './RemoteConfigUtils';

const DEFAULT_CS_PHONE = '+18558794688';

export const NumberUtils = {
  /**
   * @param phone +18558794688
   * @param style traditional | simplified
   * @returns traditional: (855) 879-4688
   * @returns simplified: 855-879-4688
   */
  formatUSPhoneNumber(phone: string, style: 'traditional' | 'simplified') {
    const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
    const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/); // Optional country code +1
    if (match) {
      const [, areaCode, centralOffice, lineNumber] = match;

      if (style === 'traditional') {
        return `(${areaCode}) ${centralOffice}-${lineNumber}`;
      }

      return `${areaCode}-${centralOffice}-${lineNumber}`;
    }

    return phone; // Return original if it doesn't match pattern
  },
  /**
   * get CS phoneNumber
   * @returns {default: '+18558794688', formatted: '(855) 879-4688', formattedSimplified: '855-879-4688',}
   */
  getCSPhone() {
    // CS_PHONE_NUMBER is stored as "(855) 879-4688"; empty until Remote Config is fetched.
    const digits = RemoteConfigUtils.getCSPhoneNumber()
      .replace(/\D/g, '')
      .match(/^1?(\d{10})$/);
    const phone = digits ? `+1${digits[1]}` : DEFAULT_CS_PHONE;

    return {
      default: phone,
      formatted: NumberUtils.formatUSPhoneNumber(phone, 'traditional'),
      formattedSimplified: NumberUtils.formatUSPhoneNumber(phone, 'simplified'),
    };
  },
  /**
   * Formats a number by inserting a thousand separator.
   * @param num The number to format
   * @param separator The separator string (default ',')
   * @returns e.g. applyThousandSeparator(35000) → "35,000"
   */
  applyThousandSeparator(num: number, separator = ','): string {
    if (!separator) return String(num);
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  },
};
